// One chart of a database's history (System > database): a panel and a range; the server names the queries.
import { useQuery } from '@tanstack/react-query';
import { getSystemDatabaseSeriesOptions } from '../../../generated/api/@tanstack/react-query.gen.js';
import type { GetSystemDatabaseSeriesData } from '../../../generated/api/types.gen.js';
import type { MetricRange, SystemDatabaseId } from './metric-format.js';
import { refreshFor } from './RangePills.js';
import { SeriesChartCard } from './SeriesChartCard.js';

export type DatabasePanel = GetSystemDatabaseSeriesData['query']['panel'];

interface DatabaseMetricChartProps {
  databaseId: SystemDatabaseId;
  panel: DatabasePanel;
  range: MetricRange;
  title: string;
  description?: string;
  area?: boolean;
}

export function DatabaseMetricChart({ databaseId, panel, range, title, description, area }: DatabaseMetricChartProps) {
  const query = useQuery({
    ...getSystemDatabaseSeriesOptions({ path: { id: databaseId }, query: { panel, range } }),
    refetchInterval: refreshFor(range),
  });
  return (
    <SeriesChartCard
      title={title}
      description={description}
      range={range}
      data={query.data}
      loading={query.isPending}
      error={query.error}
      area={area}
    />
  );
}
